"use client";
import StyledContainer from "@/components/StyledContainer";
import React from "react";
import PracticeAreaCard from "../components/practice-area-card";
import StyledButton from "@/components/StyledButton";

const PracticeArea2 = ({ slice, practiceAreas }) => {
  practiceAreas.sort(function (a, b) {
    return a?.data?.order - b?.data?.order;
  });
  return (
    <StyledContainer
      slice={slice}
      className="md:pt-[60px] xl:pt-[80px] md:pb-[60px] xl:pb-[80px]"
    >
      <div className="mx-auto max-w-[1055px] grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-[24px] md:gap-x-[30px] md:gap-y-[60px] xl:gap-x-[68px] xl:gap-y-[40px]">
        {practiceAreas
          ?.filter((item) => item?.data?.featured)
          ?.map((item, idx) => {
            return <PracticeAreaCard key={idx} data={item} />;
          })}
      </div>
      <div className="flex justify-center mt-[24px] md:mt-[36px]">
        {slice?.primary?.button?.map((item, idx) => {
          return (
            <StyledButton
              key={idx}
              link={item?.link}
              label={item?.label}
              icon={item?.icon}
              iconPosition={item?.icon_position}
              variant={item?.variant}
              type="submit"
            />
          );
        })}
      </div>
    </StyledContainer>
  );
};

export default PracticeArea2;
